<script lang="ts">
  import { usePopoverContext } from '../use-popover-context';
  import { popoverStyles } from '../popover-styles';
  import { css } from '@agapi/ui/panda/css';
  import type { PopoverDescriptionProps } from '../popover.types';

  const { children, css: cssProp }: PopoverDescriptionProps = $props();

  const popover = usePopoverContext();
  const classes = popoverStyles.raw();
</script>

<div {...popover.api.getDescriptionProps()} class={css(classes.description, cssProp)}>
  {#if children}
    {@render children()}
  {/if}
</div>
